// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__WyWyX","operationArea":"List_operationArea__eiG62"};